const CHANGE_TIME_OPTIONS = [
  { value: 0, label: 'Allow minimum time only' },
  { value: 30, label: '30 minutes extra' },
  { value: 60, label: '1 hour extra' },
  { value: 90, label: '1 hour 30 minutes extra' },
  { value: 120, label: '2 hours extra' },
]

export function formatChangeTime(value) {
  if (Number.isFinite(value)) {
    const foundOption = CHANGE_TIME_OPTIONS.find(
      (option) => option.value === value
    )
    return foundOption || value
  } else {
    return value
  }
}

export default CHANGE_TIME_OPTIONS
